import React, { useEffect, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaRedoAlt, FaFilePdf } from "react-icons/fa"; // For retry and PDF icon
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;
const apiImage = process.env.REACT_APP_MY_ID_IMAGE;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Upload supporting evidence",
    evidenceText:
      "Upload screenshots of fraudulent or fake websites, call logs involving suspects, evidence from social media conversations (such as Instagram, Facebook, Telegram, etc.), and WhatsApp chats.",
    chooseFiles: "Choose Files",
    ok: "OK",
    errorUpload: "Please upload valid image or PDF files below 10MB.",
  },
  Hi: {
    header: "सहायक प्रमाण अपलोड करें",
    evidenceText:
      "फर्जी या धोखाधड़ी वाले वेबसाइटों के स्क्रीनशॉट, संदिग्धों के कॉल लॉग, सोशल मीडिया वार्तालापों (जैसे Instagram, Facebook, Telegram, आदि) के प्रमाण और WhatsApp चैट अपलोड करें।",
    chooseFiles: "फ़ाइल चुनें",
    ok: "ठीक है",
    errorUpload: "कृपया 10MB से कम साइज़ की वैध इमेज या PDF फ़ाइलें अपलोड करें।",
  },
  Kn: {
    header: "ಸಂಬಂಧಪಟ್ಟ ದಾಖಲಾತಿಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ.",
    evidenceText:
      "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬಳಿಯಿರುವ ವಂಚಕರ ಪುರಾವೆಗಳು ಅಥವಾ ನಕಲಿ ವೆಬ್‌ಸೈಟ್‌ಗಳು, ಅಪರಾಧದಲ್ಲಿ ಭಾಗಿಯಾಗಿರುವ ಕರೆಗೆ ಸಂಬಂಧಿಸಿದ ದಾಖಲೆಗಳು ಅಥವಾ ಯಾವುದೇ ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಸಂಭಾಷಣೆಯ ಚಾಟ್‌ಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ.",
    chooseFiles: "ಫೈಲ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    ok: "ಸರಿ",
    errorUpload: "ದಯವಿಟ್ಟು 10MBಕ್ಕಿಂತ ಕಡಿಮೆ ಗಾತ್ರದ ಮಾನ್ಯವಾದ ಚಿತ್ರ ಅಥವಾ PDF ಫೈಲ್‌ಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
  },
};

const Support = ({
  submitSupport,
  onNext,
  onQuestion,
  answer,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);
  const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB

  // Audio mapping based on language
  const audioMap = {
    en: "audio/English BOT Audios/Support.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio15.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio15.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };



  //Update audio source based on language change
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Load files from localStorage
  useEffect(() => {
    const storedFiles = localStorage.getItem("file");
    if (storedFiles) {
      const parsedFiles = JSON.parse(storedFiles);
      setFiles(parsedFiles);
      submitSupport(parsedFiles);
    }
  }, []);

  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (files.length + selectedFiles.length > apiImage) {
      setErrorMessage(`You can only upload a maximum of ${apiImage} images.`);
      return;
    }

    let errorMessages = "";
    const validFiles = selectedFiles.filter((file) => {
      const isImage =
        file.type.startsWith("image/") || file.type === "application/pdf";
      const isSizeValid = file.size <= MAX_UPLOAD_SIZE;

      if (!isImage)
        errorMessages = translations[selectedLang].errorUpload;
      if (!isSizeValid)
        errorMessages = translations[selectedLang].errorUpload;

      return isImage && isSizeValid;
    });

    setErrorMessage(errorMessages);

    if (!errorMessages) {
      const filesWithBase64 = await Promise.all(
        validFiles.map(async (file) => ({
          file,
          url: URL.createObjectURL(file),
          uuid: uuidv4(),
          name: file.name,
          type: file.type,
          status: "pending",
        }))
      );

      const newFiles = [...files, ...filesWithBase64];
      localStorage.setItem("file", JSON.stringify(newFiles));
      submitSupport(newFiles);
      setFiles(newFiles);

      uploadFiles(filesWithBase64);
    }
  };

  const uploadFiles = async (validFiles) => {
    try {
      setIsUploading(true);
      if (audioRef.current && isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      }
      for (const { file, uuid } of validFiles) {
        const formData = new FormData();
        formData.append("api_key", apiKey);
        formData.append("visitor_token", vist_id);
        formData.append("qtion_id", "66f654783112a");
        formData.append("qtion_num", "13");
        formData.append("lac_token", botToken);
        formData.append("app_ver", app_ver);
        formData.append("userImage", file);
        formData.append("ref_id", uuid);
        formData.append("type", "2");

        const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_doc`, {
          method: "POST",
          body: formData,
        });
        const fileData = await response.json();
        if (fileData.resp.error_code === "0") {
          setFiles((prevFiles) =>
            prevFiles.map((f) =>
              f.uuid === uuid ? { ...f, status: "uploaded" } : f
            )
          );

          const updatedFiles = JSON.parse(localStorage.getItem("file")).map(
            (f) => (f.uuid === uuid ? { ...f, status: "uploaded" } : f)
          );
          localStorage.setItem("file", JSON.stringify(updatedFiles));
          submitSupport(updatedFiles);
        } else {
          setErrorMessage(fileData.resp.message);
          console.error(fileData.resp.message);
          break;
        }
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemoveFile = async (index, uuid) => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_remove_doc`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f654783112a",
          qtion_num: "13",
          option_val: "670fce3010e33775926208",
          lac_token: botToken,
          app_ver: app_ver,
          ref_id: uuid,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });

      const result = await response.json();
      if (result.resp.error_code === "0") {
        setFiles((prevFiles) => prevFiles.filter((file) => file.uuid !== uuid));
        setErrorMessage("");

        const updatedFiles = JSON.parse(localStorage.getItem("file")).filter(
          (file) => file.uuid !== uuid
        );
        localStorage.setItem("file", JSON.stringify(updatedFiles));
        submitSupport(updatedFiles);
      } else {
        setErrorMessage("Failed to delete the file.");
      }
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const handleRetryUpload = (file) => {
    uploadFiles([file]); // Retry upload for the specific file
  };

  const handleSubmit = () => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    onNext(15);
    onQuestion(16);
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex" }}>
            <h2>{translations[selectedLang].header}</h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <p className="victim-para">
            {translations[selectedLang].evidenceText}
          </p>
          <input
            type="file"
            id="file-uploads"
            multiple
            onChange={handleFileChange}
            className="file-inputs"
            style={{ display: "none" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              position: "relative",
              zIndex: "9",
            }}
          >
            <label htmlFor="file-uploads" className="upload-file">
              {translations[selectedLang].chooseFiles}
            </label>
            <button
              type="button"
              style={{ width: "95px", zIndex: "1" }}
              className="ok-btn"
              onClick={handleSubmit}
            >
              {translations[selectedLang].ok}{" "}
              {files.length > 0 && <span>{` (${files.length})`}</span>}
            </button>
          </div>
          {errorMessage && (
            <div className="error-message" style={{ color: "red" }}>
              {errorMessage}
            </div>
          )}
          <div className="file-preview">
            {files.length > 0 && (
              <ul>
                {files.map(({ url, uuid, name, type, status }, index) => (
                  <li key={uuid} className="file-item">
                    <div className="image-container">
                      {type === "application/pdf" ? (
                        <div className="pdf-preview">
                          <FaFilePdf size={50} color="red" />
                          <p style={{ fontSize: "8px" }}>{name}</p>
                        </div>
                      ) : (
                        <img
                          src={url}
                          alt={`${name}`}
                          className="preview-image"
                        />
                      )}
                      <button
                        type="button"
                        onClick={() => handleRemoveFile(index, uuid)}
                        className="remove-button"
                      >
                        <RxCross2 />
                      </button>
                      {status !== "uploaded" && (
                        <div
                          className={`retry-circle ${
                            isUploading ? "rotating" : ""
                          }`}
                          onClick={() => handleRetryUpload({ url, uuid, name })}
                          style={{
                            position: "absolute",
                            top: "20%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "20px",
                            height: "20px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <FaRedoAlt
                            style={{ color: "white", fontSize: "14px" }}
                          />
                        </div>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
